import axios, { AxiosInstance } from 'axios'

export const AXIOS: AxiosInstance = axios.create({
  // Need to use relative path, so it will work in both
  // devServer and in production
  baseURL: './api',
})
